var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2337_9324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.7379 20.3359C72.0172 14.6385 64.4115 11.2051 56.3372 10.675C48.2628 10.145 40.2702 12.5545 33.8475 17.4548C27.4249 22.3552 23.0101 29.4123 21.4253 37.3121C19.8404 45.2119 21.1935 53.4159 25.2326 60.3964L20.5 77.6002L38.1846 72.9839C43.0759 75.6356 48.5566 77.025 54.1261 77.0254H54.1403C60.7373 77.0248 67.186 75.0771 72.6713 71.4285C78.1567 67.78 82.4324 62.5943 84.9579 56.5271C87.4835 50.4598 88.1456 43.7833 86.8605 37.3416C85.5753 30.8998 82.4007 24.9819 77.7379 20.3359ZM54.1403 71.4181H54.1295C49.164 71.4184 44.2898 70.0896 40.0172 67.5709L39.0043 66.9732L28.5088 69.7122L31.3105 59.5281L30.6503 58.4842C27.3826 53.3003 25.9379 47.1823 26.5435 41.092C27.149 35.0016 29.7704 29.2843 33.9955 24.8387C38.2207 20.3932 43.81 17.4716 49.8848 16.5331C55.9596 15.5947 62.1754 16.6926 67.5551 19.6544C72.9348 22.6162 77.1733 27.2738 79.6043 32.895C82.0353 38.5163 82.5209 44.7825 80.9849 50.7085C79.4488 56.6344 75.9781 61.8842 71.1185 65.6325C66.2588 69.3808 60.2857 71.415 54.1382 71.4154L54.1403 71.4181Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0332 75.6931L26.5498 59.2725C23.0508 53.2285 21.6526 46.2041 22.5718 39.2885C23.491 32.3729 26.6763 25.9523 31.6339 21.0223C36.5914 16.0923 43.0442 12.9283 49.9918 12.0208C56.9394 11.1134 63.9937 12.5131 70.0609 16.0031C76.1281 19.4931 80.8692 24.8784 83.5493 31.3239C86.2293 37.7694 86.6985 44.9152 84.8841 51.6532C83.0697 58.3912 79.0731 64.345 73.5139 68.5916C67.9547 72.8382 61.1435 75.1403 54.1363 75.141H54.1222C48.8084 75.14 43.5794 73.8144 38.9122 71.2851L22.0359 75.6904L22.0332 75.6931Z",
    fill: "url(#paint0_linear_2337_9324)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8972 29.7051C45.2801 28.3389 44.6299 28.3115 44.0431 28.288C43.5625 28.2672 43.0127 28.2686 42.4642 28.2686C42.0466 28.2796 41.6359 28.3764 41.2577 28.5531C40.8796 28.7297 40.5422 28.9823 40.2668 29.295C39.3351 30.1733 38.5974 31.2351 38.1008 32.4129C37.6042 33.5907 37.3595 34.8586 37.3823 36.1358C37.3823 40.1719 40.3355 44.0721 40.7474 44.6195C41.1592 45.1668 46.4477 53.7135 54.8226 57.0012C61.7829 59.7335 63.1996 59.1901 64.7105 59.0534C66.2214 58.9168 69.585 57.0695 70.2722 55.154C70.9593 53.2384 70.9586 51.5969 70.7527 51.2539C70.5468 50.9108 69.9976 50.7071 69.1732 50.2964C68.3487 49.8857 64.2986 47.9012 63.5428 47.6278C62.787 47.3544 62.2378 47.2177 61.6887 48.0392C61.1395 48.8606 59.5613 50.7065 59.0801 51.2552C58.5989 51.804 58.1183 51.8716 57.2946 51.4616C54.8655 50.4975 52.6235 49.12 50.6688 47.3906C48.8673 45.7331 47.3225 43.8188 46.085 41.7103C45.6045 40.8902 46.0332 40.4453 46.4471 40.0353C46.8172 39.6681 47.2708 39.0778 47.6834 38.5988C48.0215 38.1841 48.2987 37.7237 48.5065 37.2313C48.6162 37.005 48.6675 36.7551 48.6558 36.5042C48.644 36.2532 48.5696 36.0092 48.4392 35.7941C48.2312 35.3834 46.6294 31.3272 45.8972 29.7051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4639 20.2318C71.8102 14.5959 64.2913 11.1984 56.308 10.6723C48.3247 10.1462 40.4215 12.5275 34.071 17.3724C27.7205 22.2172 23.3558 29.1953 21.7902 37.0064C20.2245 44.8175 21.5646 52.9289 25.5609 59.8293L20.8828 76.8388L38.3642 72.2754C43.1993 74.8967 48.6171 76.2702 54.1226 76.2706H54.1368C60.6585 76.2711 67.034 74.3464 72.4571 70.7399C77.8802 67.1334 82.1073 62.007 84.6041 56.009C87.1009 50.011 87.7552 43.4106 86.4843 37.0423C85.2133 30.6741 82.0742 24.8241 77.4639 20.2318ZM54.1368 70.7276H54.1294C49.2207 70.7281 44.4023 69.4146 40.1786 66.9247L39.1772 66.3337L28.8007 69.0412L31.5702 58.9723L30.918 57.9405C27.6879 52.8159 26.26 46.768 26.8588 40.7474C27.4576 34.7269 30.0491 29.0751 34.226 24.6807C38.4028 20.2862 43.9282 17.3982 49.9334 16.4707C55.9386 15.5432 62.0832 16.6287 67.4012 19.5567C72.7191 22.4847 76.909 27.089 79.312 32.6459C81.715 38.2028 82.1949 44.3972 80.6763 50.2552C79.1577 56.1133 75.7266 61.3028 70.9226 65.008C66.1185 68.7132 60.2138 70.724 54.1368 70.7243V70.7276Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2337_9324",
    x: 0.5,
    y: 0.600586,
    width: 107,
    height: 107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2337_9324"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2337_9324",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2337_9324",
    x1: 54.0016,
    y1: 75.6931,
    x2: 54.0016,
    y2: 11.7515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappicon);
export default __webpack_public_path__ + "static/media/whatsappicon.9bb52434773f3e6e5cb809e427fe4a9e.svg";
export { ForwardRef as ReactComponent };